import { Plugin } from '@nuxt/types'

interface FaviconElements {
  light: HTMLLinkElement | null
  dark: HTMLLinkElement | null
}

type ThemeMode = 'light' | 'dark'

const faviconPlugin: Plugin = () => {
  // Only run on client-side
  if (process.server) return

  const favicons: FaviconElements = {
    light: null,
    dark: null
  }

  // Create favicon element
  const createFaviconElement = (mode: ThemeMode): HTMLLinkElement => {
    const element = document.createElement('link')
    element.rel = 'icon'
    element.href = mode === 'light' ? '/favicon.svg' : '/favicon-dark.svg'
    element.type = 'image/svg+xml'
    element.media = `(prefers-color-scheme: ${mode})`
    return element
  }

  // Create favicon elements
  const createFaviconElements = (): void => {
    favicons.light = createFaviconElement('light')
    favicons.dark = createFaviconElement('dark')
  }

  // Add favicon elements to head
  const addFavicons = (): void => {
    const head = document.head

    // Remove existing dynamic favicons if they exist
    const existingFavicons = document.querySelectorAll(
      'link[rel="icon"][media*="prefers-color-scheme"]'
    )
    existingFavicons.forEach((favicon) => favicon.remove())

    // Add new favicons
    Object.values(favicons).forEach((favicon) => {
      if (favicon) head.appendChild(favicon)
    })
  }

  // Initialize
  const init = (): void => {
    createFaviconElements()
    addFavicons()
  }

  // Run on mount
  init()

  // Watch for color scheme changes
  if (window.matchMedia) {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    darkModeMediaQuery.addEventListener('change', init)
  }
}

export default faviconPlugin
